export const isEmpty = (v) => !v || !String(v).trim();

export const isDni = (v) => /^\d{7,9}$/.test(String(v ?? "").trim());

export const isEmail = (v) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v ?? "").trim());

export const isYear = (v) => {
  const str = String(v ?? "").trim();
  if (!/^\d{4}$/.test(str)) return false;
  const n = Number(str);
  const max = new Date().getFullYear();
  return n >= 1990 && n <= max;
};
